export default __webpack_public_path__ + "static/media/large.946ae1fc.gif";